import AccountDetails from "../AccountDetails";
import TransactionHistory from "../TransactionHistory";

export const Views = {
  account: AccountDetails,
  transactionHistory: TransactionHistory,
}